//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wikiHead from '~/components/common/head.vue'
import { getMyCountry } from '~/assets/js/utils.js'
export default {
  components: {
    'wiki-head': wikiHead
  },
  layout: 'empty',
  data () {
    return {
      rankList: [] // 列表项
    }
  },
  head () {
    return {
      title: 404
    }
  },
  computed: {
    // 面包屑导航——首页
    breadHost () {
      return this.$store.getters?.breadHome
    }
  },
  async created () {
    const { countryCode = '840' } = this.$store.state
    const contry = getMyCountry({ countryCode })?.twoCharCode?.toLowerCase() || 'us'
    const reqUrl = `https://wiki-agg-sg.oss-ap-southeast-1.aliyuncs.com/index/release/${contry}/${this.currLangCode()}/data.json`
    try {
      const { data = {} } = await this.$axios.get(reqUrl)
      const { rankingCold = {} } = data || {}
      const { poprank = [] } = rankingCold || {}
      this.rankList = (poprank || [])?.slice(0, 5)
    } catch (err) {}
  }
}
